import axios, { AxiosInstance } from 'axios';
import { apiRoot } from '../api';
import securedAxios, { newSecuredAxios } from '../../utils/secured-axios';

interface PasswordProtected {
  protected: boolean;
}

/**
 * NOTE: use coubic v2 api
 */
export class ProductRepository {
  private api: AxiosInstance;

  constructor(api: AxiosInstance) {
    this.api = api;
  }

  public async PasswordVerify(
    publicId: string,
    productPublicId: string,
    password: string,
  ): Promise<boolean> {
    const path = `${apiRoot()}/merchants/${publicId}/products/${productPublicId}/verify`;

    return this.api
      .post(path, {
        password,
      })
      .then((response) => {
        return response.status === 200;
      })
      .catch((err) => {
        if (axios.isAxiosError(err) && err.response?.status === 401) {
          return false;
        }
        return Promise.reject(err);
      });
  }

  public async IsProtected(publicId: string, productPublicId: string) {
    const path = `${apiRoot()}/merchants/${publicId}/products/${productPublicId}/protected`;

    try {
      const res = await this.api.get<PasswordProtected>(path);

      const isProtected = res.status === 200 ? res.data.protected : undefined;
      const siteUnpublishedHeader = res.headers['x-coubic-site-unpublished'];
      const isUnpublishedSite = siteUnpublishedHeader
        ? Boolean(siteUnpublishedHeader)
        : false;
      return {
        isProtected,
        isUnpublishedSite,
      };
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const siteUnpublishedHeader =
          error.response?.headers['x-coubic-site-unpublished'];
        const isUnpublishedSite = siteUnpublishedHeader
          ? Boolean(siteUnpublishedHeader)
          : false;
        return {
          isProtected: false,
          isUnpublishedSite,
        };
      } else {
        throw error;
      }
    }
  }
}

export default new ProductRepository(securedAxios);

// SSRでAPIリクエストを行いたい場合、session情報を明示的に載せる必要があるため、
// こっちのメソッドから生成されたインスタンスを利用する
export const ProductRepositoryForSSR = (
  session: string,
  token: string,
  requestId: string,
) => {
  return new ProductRepository(newSecuredAxios({ session, token, requestId }));
};
